import angular from 'angular';

import Component from './duration-editor.component';

const Module = angular
    .module('control-room.commons.basic.components.duration-editor', [])
    .component('crDurationEditor', Component);

export default Module;
